import '.d{display:flex;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.z{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.av{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.em{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.a4{align-items:stretch;}.ssr-plugin'
import '.en{margin-top:2rem;}.ssr-plugin'
import '.a3{margin-bottom:5rem;}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="d y z e av"
      >
        <DashboardNavBar />
        <div className="em d e a4 en a3 ai"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
